import styled from 'styled-components';

import { NoSSR } from '@xing-com/crate-utils-no-ssr';

import { adSlotConfigPublift } from '../../ad-slot-config-publift';
import { useRegisterZone } from '../../hooks';

const AdWrapper = styled.div`
  max-width: 300px;
  min-height: 90px;
  position: relative;
  z-index: 1;
`;

export const DisplayAdProfileMobileSlotPublift: React.FC = () => {
  const slotId = adSlotConfigPublift.Profile.mobile.id;
  useRegisterZone(slotId);

  return (
    <NoSSR>
      <AdWrapper>
        <div
          id={slotId}
          data-fuse={adSlotConfigPublift.Profile.mobile.fuseTag}
        ></div>
      </AdWrapper>
    </NoSSR>
  );
};
